import { Flex, type ListRef, Spinner } from '@banhala/ui-kit';
import { AtomicRenderer } from 'shared/src/component';
import { useGetScreensInfiniteQuery } from './queries/useGetScreensInfiniteQuery';
import { StyleSheet, View } from 'react-native';
import { useCallback, useContext, useRef } from 'react';
import type { IScreensComponent } from 'shared/src/api';
import { useScrollToFilterList } from './hooks/useScrollToFilterList';
import { HomeScrollContext } from '../../context/HomeScrollContext';
import { useIsTabFocused } from '../../hooks/useIsTabFocused';
import { useRegisterScrollToTop } from '../../hooks/useRegisterScrollToTop';
import { useLogViewScreen } from './hooks/useLogViewScreen';

export type AtomicRendererRefCurrent = ListRef<IScreensComponent>;

export const HomeAtomic: React.FC<{
  screenName: string;
  nextToken?: string;
}> = props => {
  const atomicRendererRef = useRef<AtomicRendererRefCurrent>(null);
  const homeScroll = useContext(HomeScrollContext);
  const { data, fetchNextPage, isFetching, refetch } =
    useGetScreensInfiniteQuery(props.screenName, props.nextToken);
  const { filterListIndex, scrollToFilterList } = useScrollToFilterList({
    atomicRendererRef,
    components: data?.components,
  });

  const focused = useIsTabFocused(props.screenName);
  useLogViewScreen(data, focused);

  const handleScrollToTop = useCallback(() => {
    atomicRendererRef.current?.scrollToOffset({ offset: 0, animated: true });
  }, []);
  useRegisterScrollToTop(props.screenName, handleScrollToTop);

  if (!data) {
    return null;
  }

  return (
    <Flex flex={1}>
      {isFetching && (
        <View style={styles.spinnerContainer}>
          <Spinner size={20} />
        </View>
      )}
      <AtomicRenderer
        //나중에 바꿀값
        isForeground={true}
        refetch={refetch}
        data={data ?? []}
        screen={props.screenName}
        fetchNextPage={fetchNextPage}
        listRef={atomicRendererRef}
        filterListIndex={filterListIndex}
        scrollToFilterList={scrollToFilterList}
        isFetching={isFetching}
        onScrollY={homeScroll?.onScrollY}
        scrollYSharedValue={homeScroll?.scrollY}
        logDisabled={!focused}
        hideScrollToTop={true}
      />
    </Flex>
  );
};
const styles = StyleSheet.create({
  spinnerContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: -10 }, { translateY: -10 }],
    zIndex: 1000,
  },
});
